// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"130ce803","129":"e04d71a6","170":"cd5e4dba","501":"58124987","688":"9fcc79a6","702":"bd9e900d"}[chunkId] + ".chunk.css";
};